import React from 'react';

export default props => {
  return (
    <React.Fragment>
      <input
        defaultValue={props.value}
        className={'form-control form-control-sm ' + props.inputClass}
        style={
          props.active
            ? { width: props.size }
            : {
                borderColor: 'transparent',
                backgroundColor: 'transparent',
                width: props.size
              }
        }
        readOnly={!props.active}
        onClick={() => {
          props.setState({ [props.activeName]: props.entityId });
        }}
        onChange={e =>
          props.setState({
            [props.activeName]: props.entityId,
            inputClass:
              e.currentTarget.value.length > 0 ? 'is-valid' : 'is-invalid'
          })
        }
        onBlur={e => props.onBlur(e)}
      />
    </React.Fragment>
  );
};
